import React, { Component } from 'react';
import TableData from "./TableData/index";
import TableHead from './TableHead';
import Icons from "../../Icons/Icons";
import { isSet } from '../../../Utils/CommonFunctions';
import { checkIsOrganizationAdmin } from '../../../Utils/UserFunctions';
// import BootstrapRow from "../../../hoc/BootstrapRow";
// import BootstrapColumn from "../../../hoc/BootstrapColumn";
// import Wrp from "../../../hoc/Wrp/Wrp";

class TableContent extends Component {
    constructor(props) {
        super(props);
    }
    clickHandler = ()=>{

    }
     clearOrSelectAllRows = (boolean,selectedRows)=>{
// console.log('selectedRows',selectedRows);
          const tableDataSel = this.props.tableRecords;
             this.setState({tablecolData:[]})
             tableDataSel.tableData.data.map((item,index)=>{
                let checkBox = (tableDataSel.tableData.data[index].data && tableDataSel.tableData.data[index].data.checkBox)?tableDataSel.tableData.data[index].data.checkBox :tableDataSel.tableData.data[index].data.Checkbox;
                if(checkBox.checked===false && boolean===true){
               if(isSet(selectedRows,[]).indexOf(item.rowId) !== -1){
                   }else{
                     isSet(selectedRows,[]).push(item.rowId);
                     }
                   }
                   checkBox.checked=!boolean;
        
                   checkBox.changeHandler(checkBox)
        
               });
               
              }
        
     selectDisplayedRowsHandler = (isSelect)=>{
       if(this.props.tableRecords.tableHead.length>0){
            let selectedRows=this.props.tableRecords.selectedRows;
            this.clearOrSelectAllRows((isSelect===0)?false:true,selectedRows);

        }
       }
    sortHandler = (header) => {
        let direction = "";
        if(this.props.storageSelectionMode === true && header && (header.type === 'Checkbox' || header.type === 'GridActionWithCheckBox' || header.type === 'RadioButton' || header.type === 'Actions')) {
            return;
        }
        if(header.sortName && header.sortName !== '') {
            if (header.sortName === this.props.orderBy) {
                direction = this.props.direction === "ASC" ? "DESC" : "ASC";
            } else {
                direction = "ASC";
            }
            const pagination = {
                ...this.props,
                orderBy:header.sortName,
                direction:direction
            }
            this.props.recordsChangeHandler(pagination);    
        }
    }

    // Check if a row has a dispute field indicating a dispute
    hasDispute = (rowsData) => {
        if (!rowsData) return false;
        
        // Check all field values for dispute indicators
        // Look for fields that contain "dispute" in their name or have dispute-indicating values
        for (let key in rowsData) {
            if (rowsData.hasOwnProperty(key)) {
                const value = rowsData[key];
                const keyLower = key.toLowerCase();
                
                // Check if field name contains "dispute" and has a truthy dispute value
                if (keyLower.includes('dispute')) {
                    // Check if value indicates a dispute (1, true, "1", "true")
                    if (value === 1 || value === true || value === "1" || 
                        (typeof value === 'string' && value.toLowerCase() === "true")) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    render () {
        const tableHead = this.props.tableRecords.tableHead;
        const tableData = this.props.tableRecords.tableData;
        const isAccountAdmin = checkIsOrganizationAdmin();
        let rowsSelectedCount = null;
        if(tableData && tableData.status===200){
            const tableDataJSON = tableData.data;
            if(tableDataJSON.length===0){
                rowsSelectedCount = null;
            }else{
                rowsSelectedCount = 0;
                tableDataJSON.forEach((rows)=>{
                    const rowsData = (rows.data)?rows.data:rows;
                    const gridCheckBox = rowsData.GridActions && rowsData.GridActions.checkBox;
                    if(gridCheckBox){
                        if(gridCheckBox.checked===false){
                            rowsSelectedCount++;
                        }
                    }else{
                        const checkBox = (rowsData && rowsData.checkBox)?rowsData.checkBox : rowsData.Checkbox;
                        if(checkBox && checkBox.checked===false){
                            rowsSelectedCount++;
                        }
                    }
                });
            }
        }
             else{
                  <tr style={{"width":"100%","display":"inline-table"}}>
          				<td className="text-center" colSpan="5">
          					No Record exists 
          							</td>
          				</tr>
                }
        let ClassName = ['table','mb-0'];
        if(this.props.className){ ClassName.push(this.props.className) }
        if(this.props.margin){ ClassName.push('mt-0') }
        return (
         
                    <table className={ClassName.join(' ')} role="grid" >
                        <TableHead 
                            tHeadClassName={this.props.tHeadClassName}
                            tableHead={tableHead}
                            tableData={tableData} 
                            rowsSelectedCount={rowsSelectedCount}
                            sortHandler={this.sortHandler}
                            changeHandler={this.selectDisplayedRowsHandler}
                            storageSelectionMode={this.props.storageSelectionMode}
                            orderBy={this.props.orderBy}
                            direction={this.props.direction}
                            />
                       
                        <tbody>
                            {(tableData.status===200 && tableData.data.length>0) ?
                                tableData.data.map((rows,rowIndex)=>{
                                    let colInc = 0;
                                    let colIndex = 0;
                                    let rowsData = (rows.data)?rows.data:rows;
                                    const hasDisputeField = this.hasDispute(rowsData);
                                    const shouldHighlight = isAccountAdmin && hasDisputeField;
                                    
                                    let rowsEvent = {
                                        onClick:(rows.clickHandler)?rows.clickHandler:this.clickHandler(),
                                        className:(rows.className)?rows.className:"",
                                    }
                                    
                                    // Add dispute row class and style if needed
                                    if (shouldHighlight) {
                                        rowsEvent.className = (rowsEvent.className ? rowsEvent.className + " " : "") + "dispute-row-highlight";
                                    }
                                    
                                    return (
                                        <tr key={"row"+rowIndex} {...rowsEvent}>
                                            {Object.entries(rowsData).map(([key, colData]) => {
                                                 colInc++;
                                                 colIndex = (colInc-1);
                                                 if(colInc<=tableHead.length && tableHead[colIndex].isShow && tableHead[colIndex].isShow===true){
                                                    // Check condition and hide action more option if select one or more
                                                     let colDataAlter = colData;
                                                     if(key==='GridActions'){
                                                         colData.tableAction.map((btn,btnKey)=>{
                                                            if(btn.isButtonGroup===true && btn.btnType==='ACTIONMORE'){
                                                                colDataAlter.tableAction[btnKey].list[0].style = {display:(this.props.tableRecords.selectedRows.length>1)?'none':''};
                                                            }
                                                        });
                                                     }
                                                    return(  
                                                            <TableData 
                                                            key={"col"+colIndex} 
                                                            id={"col_"+colIndex+'_'+rowIndex} 
                                                            header={tableHead[colIndex]} 
                                                            colData={colDataAlter}
                                                            storageSelectionMode={this.props.storageSelectionMode}
                                                            />
                                                    )
                                                }
                                            })}
                                        </tr> 
                                    );
                                })
                            : <tr><td colSpan={tableHead.length} className="text-center"> No Record exists </td></tr>
                            } 
                            
                        </tbody>
                    </table>
            
            
        )
    }
}

TableContent.defaultProps = {
    storageSelectionMode: false
}

export default TableContent;